/*
 * @Author: zxf
 * @Date: 2021-12-15 14:31:44
 * @LastEditors: zxf
 * @LastEditTime: 2022-09-13 11:20:30
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\snap\SnapAllFeature.js
 */
import SnapActor from "./SnapActor";
export default class SnapAllFeature extends SnapActor{
    constructor(options) {
		super(options);
		this.type = 'SnapAllFeature';
    }

    snap(point) {
		var bounds = this.getSnapBox(point);
		let scenes = this.sceneRegister.scenes;
		let camera = this.scene.getActiveCamera();
		let interactables = [];
		for (let sceneKey in scenes) {
			if(sceneKey != 'feedback') {
				scenes[sceneKey].traverseVisible(node => {
					if (node.visible && !node.isScene && node.prop) {
						let geometry = node.prop.geo;
						let obj = {};
						obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
						obj.object = node.prop;
						interactables.push(obj);
					}
				});
			}
		}

		let features = [];
		for(let i = 0;i< interactables.length;i++) {
			let ele = interactables[i];
			if(!turf.booleanDisjoint(ele.geo, bounds)) {
				features.push(ele.object);
			}
		}
		return features;
    }
}
